import { ILevelData } from '../../State/Player/IPlayerState';
import { getNewLevelData } from '../../State/Player/PlayerLevelHelper';

export function getLevelDataBasedFromScores(
    scores: number[],
    starsPerLevel: any
): ILevelData[] {
    const levelData: ILevelData[] = [];

    // For each level score, get the number of stars based on it.
    scores.forEach((score: number, index: number) => {
        const levelNumber: number = index + 1;
        let stars: number = 3;

        if (!isNaN(score) && typeof score === 'number') {
            const requiredScores: number[] = starsPerLevel[levelNumber];
            if (requiredScores) {
                const starsIndex: number = requiredScores
                    .slice()
                    .reverse()
                    .findIndex((target: number) => target <= score);
                if (starsIndex === -1) {
                    stars = 1;
                } else {
                    stars = Math.max(1, requiredScores.length - starsIndex);
                }
            }
        }

        levelData.push(getNewLevelData({ levelNumber, stars }));
    });

    return levelData;
}
